import { render, staticRenderFns } from "./UiComment.vue?vue&type=template&id=00b40a7a&"
import script from "./UiComment.vue?vue&type=script&lang=js&"
export * from "./UiComment.vue?vue&type=script&lang=js&"
import style0 from "./UiComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports